import { render, staticRenderFns } from "./LeadPropertyDetails.vue?vue&type=template&id=ed22fcd0&scoped=true&"
import script from "./LeadPropertyDetails.vue?vue&type=script&lang=js&"
export * from "./LeadPropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadPropertyDetails.vue?vue&type=style&index=0&id=ed22fcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed22fcd0",
  null
  
)

export default component.exports